import React, { useEffect, useState } from 'react'

import "./intro-screen-ui.css"
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import CorePopUp from '../../cvp-webgames-core/Components/ui/react/core-pop-up';
import { BaseConfig } from '../BaseConfig';
import Button2 from '../general/button2';
import { generalAudioCaching } from '../../misc/tools';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import MentorUI from './mentor-ui';
import MediaControlsUI from './media-controls-ui';
import ReplayContentUI from './replay-content-ui';

const mediaId = Tools.generateGuid()
let isStopping = false;
const IntroScreenUI = (props: UIProperties<IntroScreenUIConfig>) => {
	const [isInit, setIsInit] = useState(false);

	useEffect(() => {
		if(!isInit) {
			setIsInit(true);
		}
		Tools.getGameManager().SoundManager.stopAllSounds();
		(window as any)['media-controls-on-video-loaded' + mediaId] = () => {
			if(props.parameters.audioUrls && props.parameters.audioUrls.length > 0) {
				var indx = 0;
				(window as any)['mentor-ui-update-video-playing' + mediaId](true);
				const playNext = () => {
					if(props.parameters.audioUrls.length <= indx || isStopping) {
						(window as any)['mentor-ui-update-video-playing' + mediaId](false);
						return;
					}
					Tools.playOneShotSound(props.parameters.audioUrls[indx], () => {
						indx++;
						playNext();
					}, true);
				}
				playNext();
			}
		}
	}, []);

	return (
		<div className="modal-disable-select intro-screen-ui black-overlay" style={{
		}}>
			<div className='intro-screen-ui-inner center-element'>
				<CorePopUp topId='IntroScreenUI-top' title={props.parameters.title} style={{
					backgroundColor: 'lightgray'
				}} onRenderContent={() => {
					return (
						<div className='intro-screen-ui-content'>
							<div className='intro-screen-ui-content-content-container background2'>
								<div className='intro-screen-ui-content-content-container-inner' style={{position: 'relative'}} >
									{props.parameters.spaceForMentor ? <div className='intro-screen-ui-content-content-container-mentor'>
										{/* <MentorUI mediaId={mediaId} talkingVideoSrc={props.parameters.mentorUrl} chapterId={props.parameters.mentorChapter}></MentorUI> */}
									</div> : (null)}
									{props.parameters.spaceForMentor ? <div tabIndex={0} style={{
										position: 'absolute',
										right: '15px',
										width: '840px',
									}} dangerouslySetInnerHTML={{ __html: props.parameters.htmlData }}>
									</div> : (<div tabIndex={0} dangerouslySetInnerHTML={{ __html: props.parameters.htmlData }}></div>)}
									
								</div>
								{/* {props.parameters.mentorUrl ? (
									<div style={{
										width: '990px',
										height: '100px',
										position: 'absolute',
										top: '554px',
										left: '50%',
										transform: 'translatex(-50%)'
									}}>
										<MediaControlsUI mediaId={mediaId}></MediaControlsUI>
									</div>
								) : (null)} */}
							</div>

							{props.parameters.onReplayContentClicked ?
								(<div className='intro-screen-ui-replay-bttn'>
									<ReplayContentUI title='Replay Section' onReplayContentClicked={props.parameters.onReplayContentClicked}></ReplayContentUI>
								</div>) : null}

							<div className='intro-screen-ui-content-confirm-bttn-container center-element-horizontal'>
								<Button2 width= '100%'
									height= '100%'
									idFor508='IntroScreenUI-bottom'
									onClick= {() => {
										isStopping = true;
										setTimeout(() => {
											isStopping =false;
										}, 3000);
										setTimeout(() => {
											Tools.getGameManager().SoundManager.stopAllSounds();
											props.parameters.onStartScenarioClicked();
										}, 0);
										
									}}
									onRenderContent= {() => {
										return (
											<div>
												<p className='intro-screen-ui-content-btn-confirm-text center-element-vertical black-text'>{props.parameters.buttonText}</p>
											</div>
										)
									}}
									isSelected= {false}
									ariaLabel= {props.parameters.buttonText}></Button2>
							</div>
						</div>
					);
				}}></CorePopUp>
			</div>
		</div>
	);

};

export interface IntroScreenUIConfig extends BaseConfig {
	title: string;
	onReplayContentClicked?: () => void;
	htmlData: string;
	spaceForMentor?:boolean;
	buttonText: string;
	audioUrls?: string[];
	onStartScenarioClicked?: () => void;
}

export default IntroScreenUI;